<template>
  <div :class="'col-md-' + col" class="select">
    <label :style="{'font-size': fontLabel}">{{ label }} <span v-if="isRequired">*</span></label>
    <div class="select-content">

      <select v-if="nameOnlyString" v-model="selectedOptionString" tabindex="0">
        <option v-for="(value,index) in options" :value="value" :key="index">
          {{ value }}
        </option>
      </select>

      <select v-else-if="nameOnlyString && valueSelected" v-model="contentValueSelected" tabindex="0">
        <option v-for="(value,index) in options" :value="value" :key="index">
          {{ value }}
        </option>
      </select>

      <select v-else-if="valueIsNumber" v-model="selectedOptionNumber" tabindex="0">
        <option v-for="(value,index) in options" :value="value.id" :key="index">
          {{ value.name }}
        </option>
      </select>
      <select v-else-if="valueIsNumber && valueSelected" v-model="contentValueSelected" tabindex="0">
        <option v-for="(value,index) in options" :value="value.id" :key="index">
          {{ value.name }}
        </option>
      </select>

      <select v-else-if="valueSelected" v-model="contentValueSelected" tabindex="0">
        <option v-for="(value,index) in options" :value="value.id" :key="index">
          {{ value.name }}
        </option>
      </select>

      <select v-else v-model="selectedOption" tabindex="0">
        <option v-for="(value,index) in options" :value="value.id" :key="index">
          {{ value.name }}
        </option>
      </select>

      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.75">
          <path d="M7.00002 10L12 15L17 10H7.00002Z" fill="#191919"/>
        </g>
      </svg>
    </div>
    <span :style="fontError ? 'font-size: 14px; bottom: -22px' : ''" class="select-error" v-if="inputError">Selecione algum item *</span>
  </div>
</template>

<script>
export default {
  name: "inputSelect",
  props: {
    label: {
      required: true,
    },
    options: {
      required: true,
    },
    isRequired: {
      default: false,
    },
    col: {
      required: true,
    },
    inputError: {
      default: false,
    },
    nameOnlyString: {
      default: false
    },
    valueIsNumber: {
      default: false,
    },
    valueSelected: {
      default: false
    },
    contentValueSelected: {
      default: '',
    },
    fontLabel: {
      default: ''
    },
    fontError: {
      default: false
    },
  },
  data() {
    return {
      selectedOption: '',
      selectedOptionNumber: 0,
      selectedOptionString: 'Selecione',
    }
  },
  watch: {
    selectedOption(newValue, oldValue) {
      this.$emit('selectedOption', newValue)
    },
    selectedOptionNumber(newValue, oldValue) {
      this.$emit('selectedOptionNumber', newValue)
    },
    selectedOptionString(newValue, oldValue) {
      this.$emit('selectedOptionString', newValue)
    },
    contentValueSelected(newValue, oldValue) {
      this.$emit('contentValueSelected', newValue)
    },
  }
}
</script>

<style lang="scss" scoped>

.select {
  position: relative;
  margin-bottom: 20px;

  label {
    font-size: 14px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 4px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #FF445D;
    }
  }

  &-content {
    position: relative;

    svg {
      position: absolute;
      right: 10px;
      top: 6px;
      color: var(--dark-gray);
      cursor: pointer;
      pointer-events: none;
    }

    select {
      width: 100%;
      background: #EEF2F7;
      border-radius: 4px !important;
      padding: 6px 12px;
      border: 1px solid #EEF2F7;
      transition: .2s;
      font-size: 16px;
      font-weight: 400;
      color: #3A424E;
      cursor: pointer;

      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      &::placeholder {
        font-size: 16px;
        font-weight: 400;
        color: #7E8DA7;
      }

      &:hover {
        transition: .2s;
        border: 1px solid #CACACA;
      }

      &:focus-visible {
        outline: none;
        transition: .2s;
        border: 1px solid #CACACA;

        &::placeholder {
          transition: .1s;
          color: #EEF2F7;
        }
      }

      & + svg {
        transform: rotate(0deg);
        transition: transform 0.2s ease-in-out;
      }

      &:focus {
        & + svg {
          transform: rotate(180deg);
        }
      }
    }
  }

  &-error {
    position: absolute;
    left: 15px;
    bottom: -15px;
    font-size: 11px;
    color: #D9534F;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputSelect.vue